/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-07-08T11:03:21.493
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import BasicLayout from '@/layouts/basic-layout';

const meta = {
auth: true
};

const pre = 'rentmanage-RentMaterialReceivingMainForm-'

export default 
{
path: '/rentmanage/rentmaterialreceivingmainform',
name: 'rentmanage-RentMaterialReceivingMainForm',
redirect: {
name: '${pre}-index'
}
,

meta:{
...meta,
},

component: BasicLayout ,
children:
[
{
path: 'index',
name: '${pre}RentMaterialReceivingMainForm-index',

meta:{
...meta,
title: '材料领取'
},

component: () => import('@/pages/rentmanage/rentmaterialreceivingmainform/index') ,
},
{
path: 'detail-edit/:id',
name: '${pre}RentMaterialReceivingMainForm-detail-edit',
auth: [
'hidden'
],

meta:{
...meta,
title: '材料领取编辑'
},

component: () => import('@/pages/rentmanage/rentmaterialreceivingmainform/detail-edit') ,
},
{
path: 'detail-edit',
name: '${pre}RentMaterialReceivingMainFormdetail-create',
auth: [
'hidden'
],

meta:{
...meta,
title: '材料领取新增'
},

component: () => import('@/pages/rentmanage/rentmaterialreceivingmainform/detail-edit') ,
},
{
path: 'detail-view/:id',
name: '${pre}RentMaterialReceivingMainFormView',
auth: [
'hidden'
],

meta:{
...meta,
title: '材料领取详情查看'
},

component: () => import('@/pages/rentmanage/rentmaterialreceivingmainform/detail-view') ,
},
]
};
